// Sticky Add to Cart JavaScript
(function() {
  'use strict';

  function initStickyAddToCart() {
    const stickyATC = document.querySelector('[data-sticky-add-to-cart]');
    if (!stickyATC) return;

    const productSection = document.querySelector('section-product');
    if (!productSection) return;

    // Find the product form buttons element
    const productFormButtons = productSection.querySelector('.product-form__buttons');
    if (!productFormButtons) return;

    const stickyForm = stickyATC.querySelector('#sticky-product-form');
    const stickySubmitBtn = stickyATC.querySelector('[data-sticky-atc-submit]');
    const stickyVariantId = stickyATC.querySelector('[data-sticky-atc-variant-id]');
    const stickyPrice = stickyATC.querySelector('[data-sticky-atc-price]');
    const stickyVariants = stickyATC.querySelector('[data-sticky-atc-variants]');
    const stickyQuantity = stickyATC.querySelector('[data-sticky-atc-quantity]');
    const stickyImage = stickyATC.querySelector('.sticky-add-to-cart__image img');
    
    const mainForm = productSection.querySelector('form[action*="/cart/add"]');
    const mainVariantId = mainForm?.querySelector('input[name="id"]');
    const mainPrice = productSection.querySelector('[data-update-price]');
    const mainVariants = productSection.querySelector('component-product-variant-selectors');
    const mainQuantity = productSection.querySelector('[data-product-quantity-selector]');
    const mediaGallery = productSection.querySelector('component-product-media-gallery');
    
    const quickCart = document.querySelector('section-quick-cart');
    let isScrolled = false;

    // Initialize Intersection Observer for scroll detection
    function initStickyATC() {
      // Use scroll event to check when product form buttons goes out of view
      const checkScrollPosition = () => {
        const buttonsRect = productFormButtons.getBoundingClientRect();
        const buttonsBottom = buttonsRect.bottom;
        
        // Show sticky bar when bottom of product form buttons is above viewport (scrolled past)
        if (buttonsBottom < 0) {
          if (!isScrolled) {
            stickyATC.classList.add('is-visible');
            isScrolled = true;
          }
        } else {
          // Hide sticky bar when product form buttons bottom is in view (scrolled back up)
          if (isScrolled) {
            stickyATC.classList.remove('is-visible');
            isScrolled = false;
          }
        }
      };

      // Use Intersection Observer for better performance
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const rect = entry.boundingClientRect;
            // Show sticky bar when product form buttons bottom is above viewport
            if (rect.bottom < 0) {
              if (!isScrolled) {
                stickyATC.classList.add('is-visible');
                isScrolled = true;
              }
            } else {
              // Hide sticky bar when product form buttons bottom is visible
              if (isScrolled && rect.bottom >= 0) {
                stickyATC.classList.remove('is-visible');
                isScrolled = false;
              }
            }
          });
        },
        {
          rootMargin: '0px',
          threshold: [0, 1]
        }
      );

      observer.observe(productFormButtons);
      
      // Fallback: Also use scroll event for immediate response
      let ticking = false;
      window.addEventListener('scroll', () => {
        if (!ticking) {
          window.requestAnimationFrame(() => {
            checkScrollPosition();
            ticking = false;
          });
          ticking = true;
        }
      }, { passive: true });
      
      // Check initial state
      const checkInitialState = () => {
        checkScrollPosition();
      };
      
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', checkInitialState);
      } else {
        setTimeout(checkInitialState, 100);
      }
      window.addEventListener('load', checkInitialState);
    }

    // Sync variant selection from main form to sticky form
    function syncVariantSelection() {
      if (mainVariantId && stickyVariantId) {
        stickyVariantId.value = mainVariantId.value;
        
        // Update sticky image if variant has featured media
        if (stickyImage && mediaGallery) {
          const selectedVariantData = productSection.querySelector('[data-selected-variant]');
          if (selectedVariantData) {
            try {
              const variantData = JSON.parse(selectedVariantData.textContent);
              if (variantData.featured_media && variantData.featured_media.src) {
                stickyImage.src = variantData.featured_media.src;
                stickyImage.srcset = variantData.featured_media.srcset || '';
                stickyImage.alt = variantData.featured_media.alt || '';
              }
            } catch (e) {
              // Fallback: try to get image from media gallery
              const activeMedia = mediaGallery.querySelector('.swiper-slide-active img, [data-media-id] img');
              if (activeMedia) {
                stickyImage.src = activeMedia.src;
                stickyImage.srcset = activeMedia.srcset || '';
                stickyImage.alt = activeMedia.alt || '';
              }
            }
          }
        }
      }
    }

    // Sync price from main form to sticky form
    function syncPrice() {
      if (mainPrice && stickyPrice) {
        const priceHTML = mainPrice.innerHTML;
        stickyPrice.innerHTML = priceHTML;
      }
    }

    // Sync quantity from main form to sticky form
    function syncQuantity() {
      if (mainQuantity && stickyQuantity) {
        const mainQuantityInput = mainQuantity.querySelector('input[name="quantity"]');
        const stickyQuantityInput = stickyQuantity.querySelector('input[name="quantity"]');
        if (mainQuantityInput && stickyQuantityInput) {
          stickyQuantityInput.value = mainQuantityInput.value;
        }
      }
    }

    // Update sticky form button state
    function updateStickyButtonState() {
      if (!stickyVariantId || !stickySubmitBtn) return;
      
      const variantId = stickyVariantId.value;
      if (!variantId) {
        stickySubmitBtn.disabled = true;
        stickySubmitBtn.querySelector('span').textContent = document.querySelector('.product-form__submit .atc-text')?.textContent || 'Unavailable';
        return;
      }

      // Check if variant is available
      const variantInput = mainForm?.querySelector(`input[name="id"][value="${variantId}"]`);
      if (variantInput && variantInput.disabled) {
        stickySubmitBtn.disabled = true;
        stickySubmitBtn.querySelector('span').textContent = 'Sold out';
      } else {
        stickySubmitBtn.disabled = false;
        stickySubmitBtn.querySelector('span').textContent = document.querySelector('.product-form__submit .atc-text')?.textContent || 'Add to cart';
      }
    }

    // Handle sticky form submission
    function handleStickyFormSubmit(event) {
      event.preventDefault();
      if (stickySubmitBtn.classList.contains('active')) return;

      syncVariantSelection();
      syncQuantity();

      stickySubmitBtn.classList.add('active');
      const config = {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(stickyForm)
      };

      fetch(`${window.routes?.cart_add_url || '/cart/add'}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            // Error handling
            document.dispatchEvent(
              new CustomEvent('theme-cart:updated', {
                detail: { shouldOpenCart: false, error: response.description }
              })
            );
            return;
          } else if (!quickCart) {
            window.location = window.routes?.cart_url || '/cart';
            return;
          }
          document.dispatchEvent(
            new CustomEvent('theme-cart:updated', {
              detail: { shouldOpenCart: true }
            })
          );
        })
        .catch((error) => {
          console.error('Sticky ATC error:', error);
        })
        .finally(() => {
          stickySubmitBtn.classList.remove('active');
        });
    }

    // Listen for variant changes
    document.addEventListener('theme-variantOption:changed', (event) => {
      if (event.detail && event.detail.sectionId === productSection.dataset.section) {
        setTimeout(() => {
          syncVariantSelection();
          syncPrice();
          syncQuantity();
          updateStickyButtonState();
        }, 150);
      }
    });

    // Listen for cart updates
    document.addEventListener('theme-cart:updated', () => {
      setTimeout(() => {
        syncPrice();
        updateStickyButtonState();
      }, 100);
    });

    // Listen for quantity changes
    if (mainQuantity) {
      const quantityInputs = mainQuantity.querySelectorAll('input[name="quantity"]');
      quantityInputs.forEach(input => {
        input.addEventListener('change', () => {
          syncQuantity();
        });
      });
    }

    // Attach form submit handler
    if (stickyForm) {
      stickyForm.addEventListener('submit', handleStickyFormSubmit);
    }

    // Initialize
    initStickyATC();
    syncVariantSelection();
    syncPrice();
    syncQuantity();
    updateStickyButtonState();

    // Update on scroll (fallback)
    let scrollTimeout;
    window.addEventListener('scroll', () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        syncVariantSelection();
        syncPrice();
        syncQuantity();
        updateStickyButtonState();
      }, 100);
    }, { passive: true });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyAddToCart);
  } else {
    initStickyAddToCart();
  }
})();

